import { useEffect, useRef } from "react";
import { DfyOrderFormStepId, DfyStepConfig } from "../dfy-order-form-steps";

export default function DfyStepper({
  steps,
  currentIndex,
  onStepClick,
}: {
  steps: DfyStepConfig[];
  currentIndex: number;
  onStepClick: (stepId: DfyOrderFormStepId) => void;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  const stepRefs = useRef<(HTMLButtonElement | null)[]>([]);

  useEffect(() => {
    const container = containerRef.current;
    const step = stepRefs.current[currentIndex];
    if (!container || !step) return;
    container.scrollTo({
      left: step.offsetLeft - (container.clientWidth - step.offsetWidth) / 2,
      behavior: "smooth",
    });
  }, [currentIndex]);

  return (
    <div className="relative -mx-4 mb-6 sm:mx-0 sm:mb-10">
      <div
        ref={containerRef}
        className="relative flex scrollbar-none items-center overflow-x-auto px-4 [-ms-overflow-style:none] sm:px-0 [&::-webkit-scrollbar]:hidden"
      >
        {steps.map((item, index) => {
          const isCurrent = index === currentIndex;
          const isComplete = index < currentIndex;
          return (
            <div key={item.id} className="contents">
              {index > 0 && (
                <span className="mx-2 h-px min-w-3 flex-1 shrink-0 bg-grey-200 sm:mx-3 sm:min-w-4" />
              )}
              <button
                ref={(element) => {
                  stepRefs.current[index] = element;
                }}
                type="button"
                disabled={!isComplete}
                onClick={() => onStepClick(item.id)}
                className={`shrink-0 rounded-full border px-2.5 py-1 text-sm font-semibold whitespace-nowrap sm:px-3 ${
                  isCurrent
                    ? "border-tertiary-400/5 bg-tertiary-100 text-tertiary-400"
                    : isComplete
                      ? "cursor-pointer border-transparent text-text-primary"
                      : "border-transparent text-text-secondary/50"
                }`}
              >
                {item.label}
              </button>
            </div>
          );
        })}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-4 bg-linear-to-r from-background via-background/75 to-transparent sm:hidden" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-4 bg-linear-to-l from-background via-background/75 to-transparent sm:hidden" />
    </div>
  );
}
